/* 표시용 포맷. 레퍼런스 app.js 의 fmt·kfmt·fmtTime·josa·clipTxt 와 같은 결과를 낸다. */

export function fmt(n: number): string {
  return Number(n).toLocaleString('ko-KR')
}

/** 1.2만 · 3.4K 처럼 짧게 */
export function kfmt(n: number): string {
  if (n >= 10000) return (n / 10000).toFixed(1).replace(/\.0$/, '') + '만'
  if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
  return String(n)
}

/** 하루 중 분 → "오후 3:52" (새벽 0~4시는 "새벽") */
export function fmtTime(min: number): string {
  const m0 = ((min % 1440) + 1440) % 1440
  const h = Math.floor(m0 / 60)
  const m = m0 % 60
  let ap = h < 12 ? '오전' : '오후'
  const hh = h % 12 === 0 ? 12 : h % 12
  if (h < 5) ap = '새벽'
  return `${ap} ${hh}:${m < 10 ? '0' : ''}${m}`
}

/** 받침 유무로 조사를 붙인다. pair 는 "가/이" 처럼 받침 없음/있음 순서 */
export function josa(word: string, pair: string): string {
  const s = String(word || '')
  const ch = s.charCodeAt(s.length - 1)
  const jong = ch >= 0xac00 && ch <= 0xd7a3 && (ch - 0xac00) % 28 > 0
  const [without, withBatchim] = pair.split('/')
  return s + (jong ? withBatchim : without)
}

/** 남은 ms → "N일 HH:MM:SS" */
export function countdown(ms: number): string {
  const s = Math.floor(Math.max(0, ms) / 1000)
  const d = Math.floor(s / 86400)
  const h = Math.floor((s % 86400) / 3600)
  const m = Math.floor((s % 3600) / 60)
  const ss = s % 60
  const p = (n: number) => (n < 10 ? '0' : '') + n
  return (d ? d + '일 ' : '') + p(h) + ':' + p(m) + ':' + p(ss)
}

/** 금지된 내부 기획 문구(기획안 v3, 흥행 생성기…)를 공개 문구에서 걷어낸다 */
export function productCopy(value: string | undefined | null): string {
  return String(value || '')
    .replace(
      /기획안\s*v\d+(?:\.\d+)*|흥행 생성기|변주 엔진|점수 모델\s*(?:v\d+(?:\.\d+)*)?|출시 예정\s*·\s*지표 없음/g,
      ''
    )
    .replace(/(?:\s*[·+]\s*){2,}/g, ' · ')
    .replace(/^[\s·+]+|[\s·+]+$/g, '')
    .trim()
}
